<h2>Patient Providers</h2>

<div *ngIf="activeProviders.length > 0; else noProviders">
  <mat-card class="provider-card">
    <mat-card-content>
      <ng-container *ngFor="let provider of activeProviders; let last = last">
        <div class="provider-details">
          <p><strong>First Name:</strong> {{ provider.firstName }} {{ provider.lastName }}</p>
          <p *ngIf="provider?.npi"><strong>NPI:</strong> {{ provider.npi }}</p>
          <p *ngIf="provider?.emailAddress"><strong>Email:</strong> {{ provider.emailAddress }}</p>
          <p><strong>Provider Type:</strong> {{ provider.providerTypeDisplay }}</p>
          <p><strong>Facility ID:</strong> {{ provider.facilityNumber }}</p>
        </div>

        <!-- Divider between providers -->
        <mat-divider *ngIf="!last"></mat-divider>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #noProviders>
  <div class="no-data-message">
    <mat-icon>info</mat-icon>
    <p>No active providers found for this patient.</p>
  </div>
</ng-template>

